module.exports = __webpack_public_path__ + "static/media/onboarding-gameoverview-image4.b95845a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-gameoverview-image4.png
// module id = 2707
// module chunks = 0